import React, { useState } from 'react';
import { M, initials } from '../lib/ui';

/**
 * Initials avatar that lazy-swaps to the real image once it loads.
 * Borders only, single teal — matches the mobile design system.
 */
export const Avatar = ({ name, src, size = 36, className = '' }) => {
  const [loaded, setLoaded] = useState(false);
  return (
    <span
      className={`relative inline-flex items-center justify-center rounded-full text-white font-semibold shrink-0 overflow-hidden ${className}`}
      style={{ width: size, height: size, backgroundColor: M.teal, fontSize: Math.max(11, size * 0.36) }}
      aria-hidden="true"
    >
      {!loaded && <span>{initials(name)}</span>}
      {src && (
        <img
          src={src}
          alt=""
          loading="lazy"
          onLoad={() => setLoaded(true)}
          className="absolute inset-0 w-full h-full object-cover"
          style={{ opacity: loaded ? 1 : 0, transition: 'opacity 120ms' }}
        />
      )}
    </span>
  );
};

export default Avatar;
